/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_Organization_Admin17Inputs */

const cs_role_organization_admin17 = /** @type {(inputs: Role_Organization_Admin17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrátor organizace`)
};

const en_role_organization_admin17 = /** @type {(inputs: Role_Organization_Admin17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization admin`)
};

/**
* | output |
* | --- |
* | "Organization admin" |
*
* @param {Role_Organization_Admin17Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
const role_organization_admin17 = /** @type {((inputs?: Role_Organization_Admin17Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_Organization_Admin17Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_organization_admin17(inputs)
	return cs_role_organization_admin17(inputs)
});
export { role_organization_admin17 as "role_ORGANIZATION_ADMIN" }